module.exports = __webpack_public_path__ + "static/family_pic-fbcc94d892f9f2f1516ebe803cfbc1ba.png";